import * as React from 'react';
import styled from '@emotion/styled';
import isPropValid from '@emotion/is-prop-valid';
import { colors, borderRadius } from '@workday/canvas-kit-react/tokens';
import { SystemIcon } from './SystemIcon';
import { createComponent, getColor, pickForegroundColor } from '@workday/canvas-kit-react/common';
export var SystemIconCircleSize;
(function (SystemIconCircleSize) {
    SystemIconCircleSize[SystemIconCircleSize["xs"] = 16] = "xs";
    SystemIconCircleSize[SystemIconCircleSize["s"] = 24] = "s";
    SystemIconCircleSize[SystemIconCircleSize["m"] = 32] = "m";
    SystemIconCircleSize[SystemIconCircleSize["l"] = 40] = "l";
    SystemIconCircleSize[SystemIconCircleSize["xl"] = 64] = "xl";
    SystemIconCircleSize[SystemIconCircleSize["xxl"] = 120] = "xxl";
})(SystemIconCircleSize || (SystemIconCircleSize = {}));
const Container = styled('div', {
    shouldForwardProp: prop => isPropValid(prop) && prop !== 'size',
})({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: 0,
    border: 0,
    borderRadius: borderRadius.circle,
    boxSizing: 'border-box',
    overflow: 'hidden',
    '& img': {
        width: '100%',
        height: '100%',
    },
}, ({ background }) => ({
    background: getColor(background),
}), ({ size }) => ({
    width: size,
    height: size,
}));
export const SystemIconCircle = createComponent('span')({
    displayName: 'SystemIconCircle',
    Component: ({ background = colors.soap200, size = SystemIconCircleSize.l, icon, shouldMirror, ...elemProps }, ref, Element) => {
        const iconColor = pickForegroundColor(background, 'rgba(0,0,0,0.65)', colors.frenchVanilla100);
        const iconSize = size * 0.625;
        return (React.createElement(Container, Object.assign({ background: background, size: size }, elemProps),
            React.createElement(SystemIcon, { icon: icon, color: iconColor, colorHover: iconColor, as: Element, size: iconSize, ref: ref, shouldMirror: shouldMirror })));
    },
});
